import React, { memo, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import KeepAlive, { useActivate, useUnactivate, useAliveController } from 'react-activation';

import { getClassApps, getClassesList, setClassesStatus } from '../../actions/category';
import { logging, logPostInfo } from '../../actions/log';
import Loading from '../../components/Loading/Loading';
import SoftCard from '../../components/SoftCard/SoftCard';
// import SoftCardRank from '../../components/SoftCardRank/SoftCardRank';
import { categoryKeys } from '../../constants/storageKeys';
import styles from './Category.module.less';
import qs from 'query-string';
import InfiniteScroll from 'react-infinite-scroller';
import ScrollTop from '../../components/ScrollTop/ScrollTop';
import { CONTEXT } from '../../config';

const selectAllClasses = createSelector(
  state => state.category,
  category => category,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectAllClassApps = createSelector(
  state => state.category,
  category => category.classApps,
);

function Category() {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { classes: allClassList, classesSatus } = useSelector(selectAllClasses);
  const { list, loading, pagenation } = useSelector(selectAllClassApps) || {};
  const [activeCode, setActiveCode] = useState(null);
  const [activeClass, setActiveClass] = useState(null);
  const [activeTag, setActiveTag] = useState(null);
  const [codeList, setCodeList] = useState(null);
  const [classList, setClassList] = useState(null);
  const [tagList, setTagList] = useState(null);
  const history = useHistory();
  const [initTime, setInitTime] = useState(Date.now());
  const [scrollNode, setScrollNode] = useState(null);

  const pvLog = () => {
    // 打桩-记录展现当前页面
    dispatch(
      logging({
        category: 'P',
        action: 'Classify',
        label: '',
        param2: {
          source: `Classify`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Classify',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  };
  // 浏览时长打桩
  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Classify`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  };
  useEffect(() => {
    pvLog();
    return () => {
      leaveTimeLog();
    };
  }, []);
  useActivate(() => {
    pvLog();
    setInitTime(Date.now());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  const resetclassInfo = () => {
    if (allClassList && allClassList[0]) {
      const tempCode = activeCode || (allClassList[0] && allClassList[0].code);
      setActiveCode(tempCode);
      setCodeList(allClassList);
      const tempClassList = allClassList.find(item => item.code === tempCode).appClassList;
      if (tempClassList) {
        const tempClass = activeClass || (tempClassList[0] && tempClassList[0].classId);
        setClassList(tempClassList);
        setActiveClass(tempClass);
        const tempTagList = tempClassList.find(item => item.classId === tempClass).tags;
        if (tempTagList) {
          const tempTag = activeTag || (tempTagList[0] && tempTagList[0].tagId);
          setTagList(tempTagList);
          setActiveTag(null);
        } else {
          setActiveTag(null);
          setTagList(null);
        }
      } else {
        setClassList(null);
        setTagList(null);
        setActiveClass(null);
        setActiveTag(null);
      }
    }
  };
  useEffect(() => {
    resetclassInfo();
  }, [allClassList]);

  const getQueryString = () => {
    const { code, classId, tagId } = qs.parse(window.location.search);
    // const codeClassTag = JSON.parse(sessionStorage.getItem(categoryKeys.CODE_CLASS_TAG)) || {};
    if (code) {
      // 首先判断url上面的参数。获取url中的code classId tagId, 确认跳入哪一个分类标签

      setActiveCode(code);
      if (classId) {
        setActiveClass(classId);
      }
      if (tagId) {
        setActiveTag(tagId);
      }
    }
    // else if (codeClassTag && codeClassTag.code) {
    // 其次判断sessionStorage上面的参数。获取codeClassTag, 为了处理进入详情页面回退后，回到之前选中的分类标签
    // setActiveCode(codeClassTag.code)
    // setActiveClass(codeClassTag.classId)
    // setActiveTag(codeClassTag.tagId)
    // }
  };
  // 首先设置参数，获取分类列表
  useEffect(() => {
    getQueryString();
  }, [dispatch]);
  useActivate(() => {
    if (history.action === 'PUSH') {
      getQueryString();
    }
  });

  useEffect(() => {
    dispatch(getClassesList());
    return () => {
      dispatch(
        setClassesStatus({
          list: [],
          classesSatus: true,
        }),
      );
    };
  }, []);
  useActivate(() => {
    if (!allClassList || allClassList.length < 1) {
      dispatch(getClassesList());
    }
  });
  useUnactivate(() => {
    dispatch(
      setClassesStatus({
        list: [],
        classesSatus: true,
      }),
    );
  });

  useEffect(() => {
    if (!classesSatus) {
      history.push(`${CONTEXT}/error`);
    }
  }, [classesSatus]);

  const getClassAppList = refresh => {
    if (activeCode && activeClass) {
      dispatch(
        getClassApps({
          ...pagenation,
          code: activeCode,
          id: activeClass,
          tagid: activeTag,
          skip:
            refresh ||
            activeTag !== pagenation.tagid ||
            activeClass !== pagenation.id ||
            activeCode !== pagenation.code
              ? 0
              : list.length,
          limit: 36,
          refresh,
        }),
      );
    }
  };

  useEffect(() => {
    if (activeCode && activeClass) {
      getClassAppList(true);
      dispatch(
        logging({
          category: 'C',
          action: 'Classify',
          label: '',
          param2: {
            source: `Classify`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            classId: activeClass,
            code: activeCode,
            tagId: activeTag,
          },
        }),
      );
    }
  }, [activeCode, activeClass, activeTag]);

  const handleCode = code => () => {
    const tempCode = code;
    setActiveCode(tempCode);
    const tempClassList = allClassList.find(item => item.code === tempCode).appClassList;
    if (tempClassList) {
      const tempClass = tempClassList[0] && tempClassList[0].classId;
      setClassList(tempClassList);
      setActiveClass(tempClass);
      const tempTagList = tempClassList.find(item => item.classId === tempClass).tags;
      if (tempTagList) {
        const tempTag = tempTagList[0] && tempTagList[0].tagId;
        setTagList(tempTagList);
        setActiveTag(null);
      } else {
        setTagList(null);
        setActiveTag(null);
      }
    } else {
      setClassList(null);
      setTagList(null);
      setActiveClass(null);
      setActiveTag(null);
    }
    scrollNode.scrollTop = 0;
  };

  const handleClass = classId => () => {
    const tempClass = classId;
    setActiveClass(tempClass);
    const tempTagList = classList.find(item => item.classId === tempClass).tags;
    if (tempTagList) {
      const tempTag = tempTagList[0] && tempTagList[0].tagId;
      setTagList(tempTagList);
      setActiveTag(null);
    } else {
      setActiveTag(null);
      setTagList(null);
    }
  };

  const handleTag = tagId => () => {
    setActiveTag(tagId);
  };

  const loadMore = () => {
    if (!loading && pagenation.total > ((list && list.length) || 0)) {
      getClassAppList(false);
    }
  };
  const handleLoading = () => {
    if (
      loading &&
      !(
        activeClass === pagenation.id &&
        activeCode === pagenation.code &&
        activeTag === pagenation.tagid
      ) &&
      (!list || list.length === 0)
    ) {
      return true;
    }
    return false;
  };
  return (
    <div className={styles.page} ref={r => setScrollNode(r)} pagescroll="PCStore_Page_Scroll">
      <div className={styles.page_container}>
        <div className={styles.category_apps}>
          {codeList && codeList.length > 0 && (
            <div className={styles.header}>
              {codeList.map(item => (
                <div
                  className={`${styles.header_type} ${
                    item.code === activeCode ? styles.header_type_active : ''
                  }`}
                  key={item.code}
                  onClick={handleCode(item.code)}
                >
                  {item.name}
                </div>
              ))}
            </div>
          )}
          {classList && classList.length > 0 && (
            <div className={styles.class_type}>
              {classList.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.class_type_item} ${
                    activeClass === item.classId ? styles.class_type_item_active : ''
                  }`}
                  onClick={handleClass(item.classId)}
                >
                  {item.className}
                </div>
              ))}
            </div>
          )}
          {tagList && tagList.length > 0 && (
            <div className={styles.tag_type}>
              {
                <div
                  className={`${styles.tag_type_item} ${styles.tag_type_item_active}`}
                  onClick={handleTag('')}
                >
                  {classList.find(item => item.classId === activeClass).className}
                </div>
              }
              {tagList.map((item, index) => (
                <div
                  key={index}
                  className={`${styles.tag_type_item} ${
                    activeTag === item.tagId ? styles.tag_type_son_item_active : ''
                  }`}
                  onClick={handleTag(item.tagId)}
                >
                  {item.tagName}
                </div>
              ))}
            </div>
          )}
          {!handleLoading() && (
            <div>
              <InfiniteScroll
                pageStart={1}
                loadMore={loadMore}
                hasMore={(list && list.length) < (pagenation && pagenation.total)}
                loader={
                  <div className="loader" key={0}>
                    ----------加载中----------
                  </div>
                }
                initialLoad={true}
                useWindow={false}
                getScrollParent={() => scrollNode}
                threshold={800}
              >
                <div className={styles.apps}>
                  {list &&
                    list.map(app => (
                      <SoftCard
                        soft={app}
                        logInfo={{
                          source: `Classify||${activeCode}||${activeClass}||${activeTag}`,
                          code: activeCode,
                          classname: activeClass,
                          tagname: activeTag,
                        }}
                        key={app.softID}
                      />
                      // <SoftCardRank
                      //   soft={{ ...app, cardShowDesc: true }}
                      //   logInfo={{
                      //     source: `Classify||${activeCode}||${activeClass}||${activeTag}`,
                      //     code: activeCode,
                      //     classname: activeClass,
                      //     tagname: activeTag,
                      //   }}
                      //   key={app.softID}
                      // />
                    ))}
                </div>
                {list.length >= pagenation.total && pagenation.total > 24 && (
                  <div className={styles.loader}>----------到底啦----------</div>
                )}
              </InfiniteScroll>
            </div>
          )}
        </div>

        <ScrollTop node={scrollNode} />
        {/* 判断页面处于加载中 */}
        {handleLoading() && (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}
      </div>
    </div>
  );
}

export default () => {
  return (
    <KeepAlive name="category" saveScrollPosition="screen">
      <Category />
    </KeepAlive>
  );
};
